<template>
  <el-card>
    <el-tabs type="card" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="(config, index) in tabConfigs"
        :key="index"
        :label="config.label"
        :disabled="config.disabled"
      >
        <div class="guide-item">
          <section class="title">
            <h2>{{ config.label }}</h2>
            <ul>
              <li v-for="(item) in config.menus" :key="item.key" :class="{ 'selected': activeKey === item.key }" @click="handleChangeMenu(item.key)">{{ item.label }}</li>
            </ul>
          </section>
          <keep-alive>
            <template v-for="(item) in config.menus">
              <cherry-markdown
                v-if="activeKey === item.key"
                class="markdown"
                :key="item.key"
                :markdown-id="`${item.key}`"
                :content="markdownMap[item.key]"
                readonly
              ></cherry-markdown>
            </template>
          </keep-alive>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex'
import CherryMarkdown from '@/components/CherryMarkdown'

const tabConfigs = [
  {
    label: '已签约厂牌/公司',
    menus: [
      {
        label: '入驻指引',
        key: 'signed_company_guide'
      },
      {
        label: '内容管理',
        key: 'signed_company_content_manage'
      },
      {
        label: '数据服务',
        key: 'signed_company_data_service'
      },
      {
        label: '版权服务',
        key: 'signed_company_copy_service'
      }
    ]
  },
  {
    label: '未签约厂牌/公司（免费授权）',
    menus: [
      {
        label: '入驻指引',
        key: 'unsign_company_guide'
      },
      {
        label: '内容管理',
        key: 'unsign_company_content_manage'
      },
      {
        label: '数据服务',
        key: 'unsign_company_data_service'
      },
      {
        label: '自助服务',
        key: 'unsign_company_self_service'
      }]
  },
  {
    label: '外部公司版权申诉',
    disabled: true,
    menus: []
  },
  {
    label: '内部员工',
    menus: [
      {
        label: '操作指引',
        key: 'internal_staff_guide'
      },
    ]
  }
]

export default {
  name: 'Guide',
  components: {
    CherryMarkdown
  },
  data() {
    return {
      tabConfigs,
      loading: true,
      activeKey: tabConfigs[0].menus[0].key,
    }
  },
  computed: {
    ...mapGetters(['markdownMap'])
  },
  methods: {
    handleTabClick(tab) {
      const config = tabConfigs[tab.index]
      // 反复点击同一个菜单不需要重置activeKey
      if (config.menus.map(v => v.key).includes(this.activeKey)) {
        return
      }

      this.activeKey = config.menus[0].key
    },
    handleChangeMenu(key) {
      this.activeKey = key
    }
  }
}
</script>
<style lang="scss" scoped>
.guide-item {
  display: flex;
  position: relative;
  width: 1280px;
  height: calc(100vh - 272px);
  max-height: calc(100vh - 272px);
  margin: 24px auto 0;

  .title {
    width: 300px;
    padding: 16px;
    text-align: center;
    border: 1px solid #eee;

    ul {
      list-style-type: none;
      padding-left: 0;
      margin-top: 36px;

      li {
        font-size: 14px;
        font-weight: bold;
        padding: 8px 10px;
        margin-top: 12px;
        cursor: pointer;
        border: 1px solid #eee;

        &.selected {
          color: #4071ff;
        }

        &:first-child {
          margin-top: 0;
        }
      }
    }
  }

  .markdown {
    flex: 1;
  }
}
</style>
